import PlayerCameras from './PlayerCameras';

export class DvrType {
  machineType = null;

  setMachineType(value){
    this.machineType = value;
  }

  getMachineType(){
    return this.machineType;
  }
  
  getChannelNumber(playerCamera) { // eslint-disable-line no-unused-vars
    return null;
  }

  hasCamera(playerCamera) {
    return Boolean(this.getChannelNumber(playerCamera));
  }

  getChannels(includeSplitCamera = false) {
    return PlayerCameras
      .all(includeSplitCamera, this.getMachineType())
      .filter(camera => this.hasCamera(camera))
      .map(camera => {
        const shortName = camera.replace('-camera', '');

        return {
          name: shortName,
          [camera]: true,
          [shortName]: true,
          number: this.getChannelNumber(camera)
        };
      });
  }

  getChannelsNumbers() {
    return this.getChannels().map(channel => channel.number);
  }
}

export class StandardDvrType extends DvrType {

  getChannelNumber(playerCamera) {
    switch (playerCamera) {
      case PlayerCameras.SPLIT_CAMERA: return 99;
      case PlayerCameras.FORWARD_CAMERA: return 1;
      case PlayerCameras.DRIVER_CAMERA: return 4;
      case PlayerCameras.PASSENGER_CAMERA: return 2;
      case PlayerCameras.REAR_CAMERA: return 3;
    }

    return null;
  }

}


export class ADPlusDvrType extends DvrType {

  getChannelNumber(playerCamera) {
    switch (playerCamera) {
      case PlayerCameras.SPLIT_CAMERA: return 99;
      case PlayerCameras.FORWARD_CAMERA: return 1;
      case PlayerCameras.IN_CABIN_CAMERA: return 2;
      case PlayerCameras.PASSENGER_CAMERA: return 3;
      case PlayerCameras.DRIVER_CAMERA: return 4;
    }
    return null;
  }

}

export class TwoChannelDvrType extends DvrType {

  getChannelNumber(playerCamera) {
    switch (playerCamera) {
      case PlayerCameras.SPLIT_CAMERA: return 99;
      case PlayerCameras.FORWARD_CAMERA: return 1;
      case PlayerCameras.REAR_CAMERA: return 2;
    }

    return null;
  }

}

export class DvrTypes {
  static STANDARD_DVR = new StandardDvrType();
  static TWO_CHANNEL_DVR = new TwoChannelDvrType();
  static ADPLUS2_DVR = new ADPlusDvrType();

  static forMachineType(machineType) {
    if (machineType === 1) {
      return DvrTypes.TWO_CHANNEL_DVR;
    } else if(machineType === 4){
      return DvrTypes.ADPLUS2_DVR;
    }

    return DvrTypes.STANDARD_DVR;
  }
}

export default DvrTypes;
